var map = {
	"./decidim/challenges/decidim_challenges_icon.svg": 42008,
	"./decidim/sdgs/ods-01.svg": 86021,
	"./decidim/sdgs/ods-02.svg": 49798,
	"./decidim/sdgs/ods-03.svg": 12599,
	"./decidim/sdgs/ods-04.svg": 17528,
	"./decidim/sdgs/ods-05.svg": 76681,
	"./decidim/sdgs/ods-06.svg": 51098,
	"./decidim/sdgs/ods-07.svg": 56363,
	"./decidim/sdgs/ods-08.svg": 41388,
	"./decidim/sdgs/ods-09.svg": 76845,
	"./decidim/sdgs/ods-10.svg": 84007,
	"./decidim/sdgs/ods-11.svg": 96886,
	"./decidim/sdgs/ods-12.svg": 38133,
	"./decidim/sdgs/ods-13.svg": 12500,
	"./decidim/sdgs/ods-14.svg": 45563,
	"./decidim/sdgs/ods-15.svg": 27722,
	"./decidim/sdgs/ods-16.svg": 72121,
	"./decidim/sdgs/ods-17.svg": 64200,
	"./decidim/sdgs/sdg-wheel.png": 70198,
	"./decidim/sdgs/un_emblem_square.png": 33578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12357;